import request from '../utils/request';

export function syncCorp(params) {
    return request({
        url: '/corp/sync',
        method: 'get',
        params,
        timeout: 60000
    });
}


export function initiateAuth(params) {
    return request({
        url: '/corp/auth',
        method: 'get',
        params
    });
}

export function getAuthUrl(params) {
    return request({
        url: '/corp/auth_url',
        method: 'get',
        params
    });
}

export function getCorpList(params) {
    return request({
        url: '/corp/get_list',
        method: 'get',
        params
    });
}
